<template>
  <div class="flex flex-col py-2">
    <div class="py-2">
      <router-link
        to="new-fdimm"
        class="bg-teal-400 p-1 text-white hover:bg-white hover:text-teal-400 shadow-lg"
      >New FdImm</router-link>
    </div>
    <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
      <div
        class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
      >
        <table class="min-w-full">
          <thead>
            <tr>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >Name</th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >Ausg</th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >Kf</th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >I %</th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >II %</th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >III %</th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >Db1</th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >K Var</th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >Fakt Werb PU</th>
              <th class="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr v-for="imm in immdatas" :key="imm.id">
              <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                <div class="flex items-center">
                  <div class="ml-4">
                    <div class="text-sm leading-5 font-medium text-gray-900">{{ imm.name }}</div>
                  </div>
                </div>
              </td>
              <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                <div class="text-sm leading-5 text-gray-900">{{ imm.ausg }}</div>
              </td>
              <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                <div class="text-sm leading-5 text-gray-900">{{ imm.kf }}</div>
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500"
              >
                <div class="text-sm leading-5 text-gray-900">{{ imm.ap1 }}</div>
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500"
              >
                <div class="text-sm leading-5 text-gray-900">{{ imm.ap2 }}</div>
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500"
              >
                <div class="text-sm leading-5 text-gray-900">{{ imm.ap3 }}</div>
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500"
              >
                <div class="text-sm leading-5 text-gray-900">{{ imm.db1 }}</div>
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500"
              >
                <div class="text-sm leading-5 text-gray-900">{{ imm.kvar }}</div>
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500"
              >
                <div class="text-sm leading-5 text-gray-900">{{ imm.fakt }}</div>
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-200 text-sm leading-5 font-medium"
              >
                <router-link
                  :to="{ name: 'edit-fd-imm', params: { id: imm.id } }"
                  class="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline"
                >Edit</router-link>
                <button class="ml-2" @click="deleteImm(imm.id)">
                  <i class="fa fa-trash text-gray-600"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="py-2">
      <router-link
        to="fd-imm"
        class="bg-teal-400 p-1 text-white hover:bg-white hover:text-teal-400 shadow-lg"
      >Back</router-link>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      immdatas: [],
      id: this.$route.params.id
    };
  },
  created() {
    this.getImmData();
  },
  methods: {
    getImmData() {
      axios
        .get(`${process.env.VUE_APP_API}/calculate/imm/all`)
        .then(response => {
          console.log(response);
          this.immdatas = response.data;
        });
    },
    deleteImm(id) {
      axios
        .delete(`${process.env.VUE_APP_API}/calculate/imm/${id}`)
        .then(() => this.$router.push("/fd-imm"))
        .then(
          this.$notify({
            group: "address",
            title: "Imm",
            text: "Imm was deleted."
          })
        )
        .catch(error => console.log(error));
    }
  }
};
</script>

<style>
</style>